import { RolePermissionModel } from '@/models/file-entities.model';

// Check action access by role
const actionAccessByRole = function(
  roles: RolePermissionModel[],
  moduleName: string,
  actionName: string
): boolean {
  let canAccess = false;
  if (roles !== undefined) {
    for (const role of roles) {
      for (const permission of role.permissions) {
        if (
          permission.module === moduleName &&
          permission.action === actionName
        ) {
          canAccess = true;
          break;
        }
      }
    }
  }
  return canAccess;
};
// Check module access by role
const moduleAccessByRole = function(
  modules: any,
  moduleName: string
): boolean {
  let canAccess = false;
  if (modules !== undefined && modules[moduleName]) {
          canAccess = true;
  }
  return canAccess;
};
// Get modules access list
const getModulesAccess = (
  roles: RolePermissionModel[],
  moduleName?: string
): string[] => {
  const modulesList: string[] = [];
  if (roles !== undefined) {
    for (const role of roles) {
      for (const permission of role.permissions) {
        if (!modulesList.includes(permission.module)) {
          modulesList.push(permission.module);
        }
      }
    }
  }
  return modulesList;
};

export { actionAccessByRole, moduleAccessByRole, getModulesAccess };
